import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/FontAwesome.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/FontAwesome.json';

export default createIconSet(glyphMap, 'FontAwesome', font);
